import React from 'react'
import { Link as LinkCore } from 'react-router-dom'

/**
 * Needs a wrapper for the Link, we can do a native 'a' tag but while we are still migrating, let it be from react-router-dom
 */
export const Link = ({
  to,
  reloadDocument,
  children,
  className,
  onClick,
}: {
  className?: string
  to: string
  reloadDocument?: boolean
  children: React.ReactNode
  onClick?: any
}) => {
  return (
    <LinkCore onClick={onClick} className={className} to={to} reloadDocument={reloadDocument || true}>
      {children}
    </LinkCore>
  )
}
